// Shared vocabulary + small helpers for the Integration Hub. The backend now
// returns the client doc and the fully-merged provider list directly (two
// SQL tables, not one JSON blob), so there's no client-side merge/strip logic
// left here — just formatting and display helpers.

export const isBlankHtml = (html) =>
    !html || html === '<p></p>' || !String(html).replace(/<[^>]*>/g, '').trim();

// TipTap normalizes an empty string to '<p></p>' the moment it mounts, which
// fires onChange once with no user input at all. Comparing HTML with strict
// equality would treat that as a real edit; this treats any two blank values
// as equal so mounting an editor never marks something dirty on its own.
export const htmlEquals = (a, b) => a === b || (isBlankHtml(a) && isBlankHtml(b));

export const fmtDate = (v) => {
    if (!v) return '—';
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
};

export const fmtDay = (v) => {
    if (!v) return '—';
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString();
};

export const fmtSize = (bytes) => {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/** 'iReady' / 'i-Ready ' -> 'iready'. Matches the backend's _provider_key —
 * used to match a live data source's title to the provider it belongs to. */
export const providerKey = (name) =>
    String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// One consistent brand tint for every avatar — a provider/contact/client's
// identity is carried by its initials and name, not by a random hash color.
export const AVATAR_BG = '#e8eefd';
export const AVATAR_FG = '#004df2';

export const CONNECTED_HELP_TEXT =
    "Connected = live and visible to the district right now. Not connected can mean two different things: "
    + "a real integration exists on the platform but isn't turned on yet, or this client was added here manually "
    + "as a placeholder — a note for later — with no real integration built at all yet.";

export function initials(name) {
    const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
